export const beautifyLabel = (label) => {
  if (!label) return false
  const mapping = {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    mbioId: 'MB.io ID',
    daimlerId: 'Daimler ID',
    MemberUntil: 'Member Until',
  }
  return mapping[label.trim?.()] || label
}

export const decoratedWithAsteriskForRequired = (schema) => {
  if (!schema) return {}
  const { required, properties } = schema
  if (!(required && properties)) return {}
  const decoratedProperties = {}
  for (const [key, value] of Object.entries(properties)) {
    const prefix = required.includes(key) ? '* ' : ''
    decoratedProperties[key] = {
      ...value,
      title: `${prefix}${value.title}`,
    }
  }
  return {
    ...schema,
    properties: decoratedProperties,
  }
}
